<template>
    <form
        :id="id"
        @submit.prevent="onSubmit"
        novalidate
    >
        <slot />
    </form>
</template>

<script>
// store
import { useActions } from '@/hooks/use-store';

export default {
    props: {
        id: {
            type: String,
            default: 'newModel'
        },
        submissionType: {
            type: String,
            default: 'submit'
        },
        typeOfPreparation: {
            type: String,
            default: null
        },
        modalOnSubmit: {
            type: Object,
            default: () => ({
                has: false
            })
        }
    },
    setup ( props, { emit }) {
        // submissão do formulário
        const { actions } = useActions();

        const onSubmit = () => {
            // Evitar submit do formulário caso o submissionType seja none
            if ( props.submissionType === 'none' )
                return;

            // Envia um emit para o componente pai caso um modal deva ser aberto antes de submeter os dados.
            if ( props?.modalOnSubmit?.has ) {
                emit( 'open-modal', props.modalOnSubmit.has );
                return;
            }

            setTimeout( () => {
                const params = {
                    ...( props.typeOfPreparation && { typeOfPreparation: props.typeOfPreparation })
                };
                actions( props.submissionType, params );
            }, 300 );
        };

        return { onSubmit };
    }
};
</script>